import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["selector", "dayOfWeek", "dayOfMonth", "monthOfYear", "interval", "intervalBlock", "intervalPeriodicityLabel"]

  connect() {
    // Store the initial interval value
    this.initialInterval = this.intervalTarget.value
    // Set up visibility based on current periodicity without resetting interval
    this.toggle({ resetInterval: false })
  }

  toggle({ resetInterval = true } = {}) {
    const periodicity = this.selectorTarget.value

    const wantDayOfWeek = periodicity === 'weekly'
    const wantDayOfMonth = periodicity === 'monthly' || periodicity === 'annually'
    const wantMonthOfYear = periodicity === 'annually'

    this.dayOfWeekTarget.hidden = !wantDayOfWeek
    this.dayOfMonthTarget.hidden = !wantDayOfMonth
    this.monthOfYearTarget.hidden = !wantMonthOfYear

    if (resetInterval) {
      this.intervalTarget.value = "1"
    } else {
      this.intervalTarget.value = this.initialInterval
    }

    this.intervalBlockTarget.classList.toggle("d-none", periodicity === "one-off")

    const labels = { weekly: "week(s)", monthly: "month(s)", annually: "year(s)", daily: "day(s)" }
    this.intervalPeriodicityLabelTarget.textContent = labels[periodicity] || ""
  }
}
